import { Box, Link, Breadcrumbs, useTheme, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import { Button } from '@verantos-dev/shared-components';

import { StepRenderer } from './components/StepRenderer';
import { WizardFooter } from './components/WizardFooter';
import { WizardSidebar } from './components/WizardSidebar';
import { useCreateProjectWizardScreen } from './useCreateProjectWizardScreen';
import { getAnnotationToolAdminProjectsPath } from '../../lib/routePaths';

export const CreateProjectWizardScreen = () => {
  const theme = useTheme();
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const { requiredFieldsFilled, setRequiredFieldsFilled, handleCancelProjectCreation } =
    useCreateProjectWizardScreen();
  return (
    <Box sx={{ p: theme.spacing(3) }}>
      <Breadcrumbs id="create-project-wizard-breadcrumbs" sx={{ fontSize: '16px' }} separator="/">
        <Link
          color="inherit"
          underline="hover"
          href="#"
          onClick={() => navigate(getAnnotationToolAdminProjectsPath())}
          data-testid="breadcrumb-manage-projects"
          sx={{ cursor: 'pointer' }}
        >
          {formatMessage({ id: 'createProjectWizard.breadcrumb.adminProjects' })}
        </Link>
        <Link
          color="inherit"
          underline="none"
          data-testid="breadcrumb-create-project"
          sx={{ fontWeight: '500' }}
        >
          {formatMessage({ id: 'createProjectWizard.breadcrumb.createProject' })}
        </Link>
      </Breadcrumbs>
      <Box id="create-project-wizard-content" sx={{ display: 'flex' }}>
        <Box sx={{ flex: 1 }}>
          <Box id="create-project-title" sx={{ py: theme.spacing(4) }}>
            <Typography variant="h4">
              {formatMessage({ id: 'createProjectWizard.title' })}
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              height: 'calc(100vh - 50px)',
              pl: theme.spacing(10),
            }}
          >
            <WizardSidebar />
            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
              <Box sx={{ flex: 1, overflow: 'auto', p: theme.spacing(4) }}>
                <StepRenderer setRequiredFieldsFilled={setRequiredFieldsFilled} />
              </Box>
              <WizardFooter
                requiredFieldsFilled={requiredFieldsFilled}
                setRequiredFieldsFilled={setRequiredFieldsFilled}
              />
            </Box>
          </Box>
        </Box>
        <Box id="create-project-right-sidebar" sx={{ width: '350px' }}>
          <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              id="cancel-create-project-button"
              variant="outlined"
              displayLabel="Cancel"
              onClickHandler={handleCancelProjectCreation}
              sx={{ fontSize: '15px', textTransform: 'none' }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
